import { Col, Row, Text } from 'components';
import { theme } from 'lib';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

const FootballImg = styled.img`
  height: ${(props) => (props.isMobile ? 282 : 354)}px;

  ${(props) =>
    props.isMobile &&
    `
    width: 357px;
    object-fit: cover;
  `}
`;

const BasketballImg = styled.img`
  height: ${(props) => (props.isMobile ? 227 : 354)}px;

  ${(props) =>
    props.isMobile &&
    `
    width: 266px;
    object-fit: cover;
  `}
`;

const Banner = (props) => {
  const { isMobile } = useSelector((state) => state.appState),
    { t } = useTranslation();

  return (
    <Col
      wid="100%"
      ht={isMobile ? '308px' : '316px'}
      marg={isMobile ? '20px 0 0' : '88px 0 0'}
      bg={theme.PRIMARY_BLACK}
    >
      <Col wid={isMobile ? '100vw' : '1140px'} center pos="relative">
        <Col
          pos="absolute"
          left={isMobile ? '0' : '110px'}
          bottom={isMobile ? '-52px' : '29px'}
          zIndex="2"
        >
          <FootballImg isMobile={isMobile} src={require('assets/images/football-banner.png')} />
        </Col>

        <Col
          pos="absolute"
          right="0"
          bottom={isMobile ? 'unset' : '29px'}
          top={isMobile ? '-21px' : 'unset'}
          zIndex="2"
        >
          <BasketballImg isMobile={isMobile} src={require('assets/images/basketball-banner.png')} />
        </Col>

        {!isMobile && (
          <React.Fragment>
            <Row
              pos="absolute"
              bg="#fff"
              ht="316px"
              wid="220px"
              left="370px"
              bottom="0"
              zIndex="1"
            />

            <Row
              pos="absolute"
              bg="#000"
              ht="404px"
              wid="510px"
              right="40px"
              bottom="0"
              zIndex="1"
            />
          </React.Fragment>
        )}

        <Col
          pos="absolute"
          zIndex="3"
          top={isMobile ? 'unset' : '-16px'}
          bottom={isMobile ? '-5px' : 'unset'}
        >
          <Text
            size={isMobile ? '65px' : '121px'}
            lineHt={isMobile ? '46px' : '97px'}
            marg={isMobile ? '0 0 0 47px' : '0 0 0 87px'}
            stencil
            col="#fff"
            style={{
              letterSpacing: isMobile ? -2.8 : -5
            }}
          >
            {t('website.everybody')}
          </Text>

          <Text
            size={isMobile ? '65px' : '121px'}
            lineHt={isMobile ? '54px' : '97px'}
            stencil
            col="#fff"
            style={{
              letterSpacing: isMobile ? -2.1 : -3.7
            }}
          >
            {t('website.playsBetter')}
          </Text>

          <Text
            size={isMobile ? '65px' : '121px'}
            lineHt={isMobile ? '54px' : '97px'}
            stencil
            col="#fff"
            style={{
              letterSpacing: isMobile ? -2.6 : -4.9
            }}
          >
            {t('website.together')}
          </Text>
        </Col>
      </Col>
    </Col>
  );
};

export default Banner;
